import { useCifraClient } from "../cifra-client";

const { cifraClient } = useCifraClient();

export default {
  getTiposPuntuaciones(options) {
    return cifraClient.get('/api_publica/v1/calificaciones/maestros/tipos_puntuaciones', options);
  },
  getTiposNotas(options) {
    return cifraClient.get('/api_publica/v1/calificaciones/maestros/tipos_notas', options);
  },
}